import { render, staticRenderFns } from "./wiki-item.vue?vue&type=template&id=394f12c6"
import script from "./wiki-item.vue?vue&type=script&lang=js"
export * from "./wiki-item.vue?vue&type=script&lang=js"
import style0 from "./wiki-item.vue?vue&type=style&index=0&id=394f12c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports